function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.664 15.067H8.531v2.566h2.133v-2.566zM10.664 18.917H8.531v2.566h2.133v-2.566zM14.931 15.067h2.133v2.566h-2.133v-2.566zM17.064 18.917h-2.133v2.566h2.133v-2.566zM11.731 15.067h2.133v2.566h-2.133v-2.566zM13.864 18.917h-2.133v2.566h2.133v-2.566zM18.131 15.067h2.134v2.566H18.13v-2.566zM20.264 18.917H18.13v2.566h2.134v-2.566zM21.33 15.067h2.134v2.566H21.33v-2.566zM23.465 18.917H21.33v2.566h2.134v-2.566zM8.53 22.767h2.134v2.566H8.531v-2.566zM17.064 22.767h-2.133v2.566h2.133v-2.566zM11.731 22.767h2.133v2.566h-2.133v-2.566zM20.264 22.767H18.13v2.566h2.134v-2.566zM21.331 22.767h2.134v2.566H21.33v-2.566z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.464 2a1 1 0 10-2 0v2.733H3.867A2.867 2.867 0 001 7.6v20.533A2.867 2.867 0 003.867 31h24.266A2.867 2.867 0 0031 28.133V7.6a2.867 2.867 0 00-2.867-2.867h-4.602V2a1 1 0 10-2 0v2.733H10.464V2zm17.67 4.733c.478 0 .866.388.866.867v1.8H3V7.6c0-.479.388-.867.867-.867h24.266zm.866 21.4V11.4H3v16.733c0 .479.388.867.867.867h24.266a.867.867 0 00.867-.867z",
  fill: "currentColor"
})));